angular.module('hcap-analytics')
.controller('CsmRaterBundleCtrl', [
  '$scope',
  '$state',
  '$stateParams',
  'InvitesService',
  'SurveyBundleService',
  function(
    $scope,
    $state,
    $stateParams,
    InvitesService,
    SurveyBundleService,
  ) {
    $scope.data = {
      loaded: false,
      error: false,
      errorMessage: null,
      state: null,
    };

    SurveyBundleService.getRaterBundleState($stateParams.participantId).then(state => {
      $scope.data.state = state;
      $scope.data.loaded = true;

      if (!state.next) {
        return $state.go('participate.rater-finish', {
          portal: $stateParams.portal,
          templateId: state.surveys?.[0]?.templateId,
          participantId: $stateParams.participantId,
        });
      }
      return $state.go('participate.questions', {
        portal: $stateParams.portal,
        asRater: true,
        templateId: state.next.templateId,
        participantId: state.next.participantGuid,
        finishRoute: 'rate-bundle',
        finishRouteParams: {
          portal: $stateParams.portal,
          participantId: $stateParams.participantId,
        },
        onFinish: InvitesService.update,
      });
    }).catch(error => {
      $scope.data.loaded = true;
      $scope.data.error = true;
      if (error && error.status === 403) {
        $scope.data.errorMessage = 'This 360 feedback link belongs to a different email address. Sign out and sign back in with the invited email account, then open the link again.';
      } else if (error && error.status === 404) {
        $scope.data.errorMessage = 'This Cumming School of Medicine rater link is no longer valid. It may have been removed or the related cohort/participant record may no longer exist.';
      } else {
        $scope.data.errorMessage = 'Unable to open this Cumming School of Medicine rater link right now. Please try again later or contact support if the problem continues.';
      }
    });
  },
]);
